export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1024w.ea90979b.png";